// Global App
export const SET_APP_STATE = 'SET_APP_STATE';
export const SET_USER = 'SET_USER';
export const SET_RELOGIN = 'SET_RELOGIN';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_CURRENT_SCREEN = 'SET_CURRENT_SCREEN';
export const SET_CURRENT_DIVISION = 'SET_CURRENT_DIVISION';
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION';
export const SET_CURRENT_SONG = 'SET_CURRENT_SONG';
export const SET_SHOW_PROOFS = 'SET_SHOW_PROOFS';
export const SET_SHOW_QUESTIONS_IN_DIVISIONS = 'SET_SHOW_QUESTIONS_IN_DIVISIONS';
export const SET_PROGRESS_MESSAGE = 'SET_PROGRESS_MESSAGE';
export const SET_PROGRESS_PERCENTAGE = 'SET_PROGRESS_PERCENTAGE';

// AudioPlayer
export const SET_IS_AUDIO_PRESENTATION_MODE = 'SET_IS_AUDIO_PRESENTATION_MODE';
export const SET_PLAYER_IS_SHOWN = 'SET_PLAYER_IS_SHOWN';
export const SET_PLAYER_SIZE = 'SET_PLAYER_SIZE';
export const SET_AUDIO_IS_READY = 'SET_AUDIO_IS_READY';
export const SET_AUDIO_QUESTION = 'SET_AUDIO_QUESTION';
export const SET_AUDIO_LYRICS = 'SET_AUDIO_LYRICS';
export const SET_AUDIO_IS_PLAYING = 'SET_AUDIO_IS_PLAYING';
export const SET_AUDIO_PULSE = 'SET_AUDIO_PULSE';
export const SET_AUDIO_IS_KARAOKE_MODE = 'SET_AUDIO_IS_KARAOKE_MODE';
export const SET_AUDIO_IS_LOOPING = 'SET_AUDIO_IS_LOOPING';
export const SET_AUDIO_HAS_ALT = 'SET_AUDIO_HAS_ALT';
export const SET_AUDIO_IS_ALT = 'SET_AUDIO_IS_ALT';
export const SET_AUDIO_IS_DUCKING = 'SET_AUDIO_IS_DUCKING';
export const SET_AUDIO_IS_SCRUBBING = 'SET_AUDIO_IS_SCRUBBING';
export const SET_AUDIO_IS_AUTO_ADVANCE = 'SET_AUDIO_IS_AUTO_ADVANCE';
export const SET_AUDIO_RATE = 'SET_AUDIO_RATE';
export const SET_AUDIO_ERROR = 'SET_AUDIO_ERROR';
